import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Row, Col } from 'antd';
// import CallHistorySummary from './callHistorySummary';
// import CallHistoryData from './callHistoryData';
import { Scrollbars } from 'react-custom-scrollbars-2';
import CallHistoryWrapper from './styles/callhistory.style';
import moment from 'moment';
import { getSecondsInTextTime } from '../../../utils/getInititials';

import * as TherapistActions from '../../../actions/therapist';



class CallHistory extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentCallIndex: 0
		}
	}
	loadMore = () => {

		const { therapists, dispatch } = this.props;
		let { groupCallHistory } = therapists;
		dispatch(TherapistActions.getGroupCallHistory({
			offset: groupCallHistory.length - 1,
			limit: 20
		}));

	}

	itemClick = (index) => {
		this.setState({
			currentCallIndex: index
		})
	}

	render() {
		const { currentCallIndex } = this.state;
		const { therapists, searchText, handleInputChange } = this.props;
		let { groupCallHistory, fetchGroupCallHistory: showLoader } = therapists;

		if (searchText !== "") {
			groupCallHistory = groupCallHistory.filter(callDetail => {
				let filterCall = callDetail.callArray.find(call => call.patient.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
				if (filterCall) {
					return true;
				}
				return false;
			}

			);
		}
		
		let showFooter = ((groupCallHistory.length === 0 || groupCallHistory.length % 10) || showLoader) ? false : true;

		return (
			<CallHistoryWrapper>
				<section className="callHistory">
					<div className="tableFilters">
						<div className="searchEntries">
							<label>call history</label>
							<input type="text" placeholder="Search" onChange={(evt) => handleInputChange(evt.target.value)} />
						</div>
					</div>
					<div className="callHistory-box">

						<Row gutter={12}>
							<Col lg={{ span: 9 }}>
								{groupCallHistory.length > 0 &&
									<div className="callhistory-summary card-panel">
										<Scrollbars>
											<div className="scrollable-content">
												{groupCallHistory.map((callDetail, index) => {
													let startTime = callDetail.startDateTime && moment.utc(callDetail.startDateTime).local();
													let endTime = callDetail.endDateTime && moment.utc(callDetail.endDateTime).local();
													if (!endTime || !(callDetail && callDetail.callArray && callDetail.callArray.length > 0)) {
														return null;
													}
													return (
														<div key={index} className={currentCallIndex === index ? 'listItem active' : 'listItem'} onClick={() => this.itemClick(index)}>
															<Row>
																<Col xs={{ span: 12 }} lg={{ span: 14 }}>
																	<div className="col">
																		<h1>{callDetail.callArray && callDetail.callArray[0] && callDetail.callArray[0].patient} {callDetail.callArray && callDetail.callArray.length > 1 && (" and " + (callDetail.callArray.length - 1) + " more")}</h1>
																		<div className="duration">
																			<h2>{startTime && startTime.format("LT")}</h2>
																			<span><img src="/images/arrow-right@2x.png" width="10" /></span>
																			<h2>{endTime && endTime.format("LT")}</h2>
																		</div>
																	</div>
																</Col>
																<Col xs={{ span: 12 }} lg={{ span: 10 }}>
																	<div className="col text-right">
																		<h3>{startTime.format("ddd, MMM DD YYYY")}</h3>
																		<div className="totalDuration">
																			<span><img src="/images/clock@2x.png" width="10" /></span>
																			<h4>{startTime && endTime && getSecondsInTextTime(endTime.diff(startTime, "seconds"))}</h4>
																		</div>
																	</div>
																</Col>
															</Row>
														</div>
													)
												})}
											</div>
										</Scrollbars>
										{showFooter &&
											<footer>
												<button className="load-more-btn" onClick={this.loadMore}>load more</button>
											</footer>
										}
										{showLoader &&
											<footer>
												<div className="history-loader">
													<div className="loader-icon"></div>
												</div>
											</footer>
										}
									</div>
								}
								{groupCallHistory.length === 0 &&
									<div className="callhistory-summary card-panel autobox">
										<h1>Your call history is empty.</h1>
									</div>
								}
							</Col>
							<Col lg={{ span: 15 }}>
								<div className="callhistory-detail card-panel">
									{groupCallHistory.length > 0 &&
										<>
											<div className="listItem no-border">
												<Row gutter={16}>
													<Col span={18}>
														<div className="col">
															<h5>Name</h5>
														</div>
													</Col>
													<Col span={6}>
														<div className="col flxend">
															<div className="right-title">
																<h5>Join & Leave Time</h5>
															</div>
														</div>
													</Col>
												</Row>
											</div>
											<Scrollbars>
												<div className="scrollable-content">
													{groupCallHistory.length > 0 && groupCallHistory[currentCallIndex] && groupCallHistory[currentCallIndex].callArray.map((callDetail, index) => {
														let startTime = callDetail.onCallDatetime && moment.utc(callDetail.onCallDatetime).local();
														let endTime = callDetail.endCallDatetime && moment.utc(callDetail.endCallDatetime).local();
														
														return (
															<div key={index} className="listItem">
																<Row gutter={16}>
																	<Col xs={{ span: 12 }} lg={{ span: 17 }} >
																		<div className="col">
																			<h1>{callDetail.patient}</h1>
																		</div>
																	</Col>
																	<Col xs={{ span: 12 }} lg={{ span: 7 }}>
																		<div className="col text-right">
																			<div className="duration flxend">
																				<h2>{startTime && startTime.format("LT")}</h2>
																				<span><img src="/images/arrow-right@2x.png" width="10" /></span>
																				<h2>{(endTime && endTime.format("LT"))}</h2>
																			</div>
																		</div>
																	</Col>
																</Row>
															</div>
														)
													})
													}
												</div>
											</Scrollbars>
										</>
									}
								</div>
							</Col>
						</Row>
					</div>
				</section>

			</CallHistoryWrapper>
		)
	}
}

export default connect(
	state => state
)(CallHistory);
